/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_LeaseholdInputs */

const en_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leasehold`)
};

const es_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrendamiento`)
};

const fr_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bail à construction`)
};

const de_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbbaurecht`)
};

const ja_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`借地権`)
};

const zh_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`租赁产权`)
};

const ar_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استئجار طويل الأمد (Leasehold)`)
};

const id_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hak Guna (Leasehold)`)
};

const it_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto di Superficie / Affitto a Lungo Termine`)
};

const ru_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лизгольд (право аренды)`)
};

const pt_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrendamento`)
};

const ko_val_leasehold = /** @type {(inputs: Val_LeaseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임차권 (Leasehold)`)
};

/**
* | output |
* | --- |
* | "Leasehold" |
*
* @param {Val_LeaseholdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_leasehold = /** @type {((inputs?: Val_LeaseholdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_LeaseholdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_leasehold(inputs)
	if (locale === "es") return es_val_leasehold(inputs)
	if (locale === "fr") return fr_val_leasehold(inputs)
	if (locale === "de") return de_val_leasehold(inputs)
	if (locale === "ja") return ja_val_leasehold(inputs)
	if (locale === "zh") return zh_val_leasehold(inputs)
	if (locale === "ar") return ar_val_leasehold(inputs)
	if (locale === "id") return id_val_leasehold(inputs)
	if (locale === "it") return it_val_leasehold(inputs)
	if (locale === "ru") return ru_val_leasehold(inputs)
	if (locale === "pt") return pt_val_leasehold(inputs)
	return ko_val_leasehold(inputs)
});